import { ContentWrapper, PDFViewer } from "@components/index";
import {
  Space,
  Typography,
  Avatar,
  TableColumnsType,
  Button,
  Pagination,
  Image,
  Spin,
  Modal,
  Row,
  Col,
  Form,
  Upload,
  UploadProps,
  message,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { get, post, put } from "@services/api.service";
import { DataTable } from "@components/index";
import { useNotification } from "@hooks/useNotification";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { useMaskId } from "~/Hooks/useMaskId";
import { useHasAccess } from "@hooks/useHasAccess";
import { Icon } from "@iconify/react";
import { permissions } from "@utils/Roles";
import { getColoriezedValue } from "~/Utils/getColorizedValue";
import { docVersionKey } from "~/Utils";
import { useQuery } from "~/Hooks/useQuery";
import styles from "../../../Contract.module.scss";
import { ContractDocument } from "~/Components/ContractDocuments/ContractDocuments";
import upload from "@assets/SVG/upload.svg";
import { useAuth } from "@hooks/useAuth";
import { UserType } from "~/Utils";
import { getFormattedDate, hasKeyString } from "@utils/CommonUtils";
import { SuccessModal } from "@components/SuccessModal/SuccessModal";
import { LoaderModal } from "@components/LoaderModal/LoaderModal";
import { debounce } from "lodash";
import pdfMake from "pdfmake/build/pdfmake";
import { get as _get } from "lodash";
import { printPdf } from "~/Utils/pdfmake/generate-pdf";

interface Props {
  documents: any;
  fullEnvelopeDetails: any;
  reviewers: any;
  setRefreshData: any;
  data: any;
  watchers: any;
}

var newDocId = 110;

export const DocumentVerisoning = ({
  documents,
  fullEnvelopeDetails,
  reviewers,
  setRefreshData,
  data,
  watchers,
}: Props) => {
  const { hasRole } = useHasAccess();
  const { openToast } = useNotification();
  const { id }: any = useParams();
  const { openNotification } = useNotification();
  const [updatedId, setUpdatedId] = useState<any>([]);
  const [isUpdateFile, setIsUpdateFile] = useState<any>(false);
  const [deleteId, setDeleteId] = useState<any>([]);
  const [createdFile, setCreatedFile] = useState<any>([]);
  const [updatedFile, setUpdatedFile] = useState<any>([]);
  const [selectedDocument, setSelectedDocument] = useState<string>("");
  const [totalRecords, setTotalRecords] = useState<any>([]);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [page, setpage] = useState<number>(0);
  const [pageStart, setPageStart] = useState<any>(0);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(10);
  const [sortOrder, setSortOrder] = useState<any>("desc");
  const [searchString, setSearchString] = useState("");
  const [clearSearch, setClearSearch] = useState(false);
  const [orderByName, setOrderByName] = useState("docVersion");
  const [loadingDocId, setLoadingDocId] = useState<string>("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [editDocument, setEditDocument] = useState<any[]>(documents);
  const [isLoading, setIsLoading] = useState(false);
  const [isBgLoading, setBgIsLoading] = useState(false);
  const [totalVersion, setTotalVersion] = useState(0);
  const [successOpen, setSuccessOpen] = useState(false);
  const [totalFiles, setTotalFiles] = useState<number>(0);
  const [internalRefresh, setInternalRefresh] = useState<boolean>(false);
  const [filesUploadedCount, setFilesUploadedCount] = useState<number>(0);
  const [loaderModal, setLoaderModal] = useState<boolean>(false);
  const UploadRef = useRef<any>("null");
  const navigate = useNavigate();
  const [docsList, setDocsList] = useState<any>([]);
  const query = useQuery();
  const { user } = useAuth();
  const { mask } = useMaskId();
  const [flag, setFlag] = useState(false);
  const [activeExpRow, setActiveExpRow] = useState<any>([]);
  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      if (file instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(file as Blob);
        reader.onload = () => resolve(reader.result);
        ``;
        reader.onerror = (error) => reject(error);
      } else {
        resolve({});
      }
    });
  };
  const handleFileChange = async (info: any, isUpdated = false) => {
    const { file, documentId } = info;
    try {
      const getUniqueName = (fileName: string) => {
        const lastDotIndex = fileName.lastIndexOf(".");
        const baseName = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
        const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : "";
        const allFiles = editDocument || [];

        let uniqueName = baseName;
        let count = 1;

        while (allFiles.some((doc) => doc.documentName === uniqueName)) {
          uniqueName = `${baseName}(${count})`;
          count++;
        }

        return uniqueName;
      };

      const base64String: any = await convertToBase64(file);
      const documentBase64 = base64String.toString().split(",")[1];
      const uniqueName = getUniqueName(file.name);

      const renamedFile = new File([file], uniqueName, { type: file.type });

      const newFile = {
        documentBase64: documentBase64,
        documentId: `${documentId}`,
        fileExtension: renamedFile.name.split(".").pop() || renamedFile.type?.split("/")[1],
        documentName: uniqueName,
        isNew: true,
        file: renamedFile,
      };

      if (newFile.file.size >= 40 * 1024 * 1024) {
        message.error("Adding the file exceeds the 40 MB limit");
        return;
      }
      if (editDocument.length + 1 > 10) {
        message.error("Adding the file exceeds the limit");
        return;
      }

      if (!isUpdated && newFile.isNew) {
        setCreatedFile((prevList: any) => [...prevList, newFile]);
      } else {
        setUpdatedFile((prevList: any) => [...prevList, newFile]);
      }

      setEditDocument((prevList: any) => [...prevList, newFile]);
    } catch (error) {
      console.error("Error converting file to base64:", error);
    }
  };

  const handleSearchChange = debounce((value: string, isLoading: boolean) => {
    setSearchString(value);
  }, 1000);

  const getDocuments = (currentPage: number, sortOrder: any, orderByName: any, searchText: any) => {
    setBgIsLoading(true);
    let url = `v1/spa/get/document/versions?envelopeId=${id}&page=${currentPage}&size=${recordsPerPage}&order=${sortOrder}&searchText=${encodeURIComponent(
      searchText
    )}&orderBy=${orderByName}`;
    get(url)
      .then((res: any) => {
        if (res && res.response && res.response.data) {
          setTotalPage(res.response.data.totalCount || 0);
          setTotalRecords(res.response.data.records);
          setTotalVersion(res.response.data.totalCount);
        }
        setBgIsLoading(false);
      })
      .catch((err) => {
        openToast({
          content: "Getting Contracts failed",
          type: "error",
        });
        setBgIsLoading(false);
      });
  };

  const handleTableSort = (column: any, sortOrder: string, page: any) => {
    let order: any = "";
    if (column.sorter) {
      if (sortOrder === "asc") {
        setSortOrder("desc");
        order = "desc";
      } else if (sortOrder === "desc") {
        setSortOrder("asc");
        order = "asc";
      }
    }
    setOrderByName(column.dataIndex);
    getDocuments(pageStart, order, column.dataIndex, searchString);
  };

  const getTemplateRecords = (envelopeId: string, key: any) => {
    if (envelopeId) {
      let order = 0;
      if (flag) {
        setFlag(true);
      } else {
        setFlag(false);
      }
      get(`v1/workflow/get/document/version?envelopeId=${envelopeId}&docVersion=${key}`)
        .then((res: any) => {
          setIsLoading(false);
          setBgIsLoading(false);
          res = res?.response?.data;
          setDocsList(res);
        })
        .catch(() => {
          openToast({
            content: "Getting data failed",
            type: "error",
          });
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    getDocuments(searchString.length > 0 ? 0 : pageStart, sortOrder, orderByName, searchString);
  }, [query, internalRefresh, pageStart, sortOrder, orderByName, searchString]);

  const columns: TableColumnsType = [
    {
      title: "Version",
      dataIndex: "docVersion",
      // render: (value: any, record: any) => {return `${value+1}.0`},
      render: (value: any, record: any) => {
        const [major, minor] = value.split(".").map(Number);
        const version = (major - 1) * 10 + minor;
        return `V${version}`;
      },
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "docVersion"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "docVersion"
            ? "descend"
            : undefined,
    },
    {
      title: "Last Updated",
      dataIndex: "updatedOn",
      render: (value: any) => getFormattedDate(value) || <Typography.Text disabled>-</Typography.Text>,
      sorter: true,
      sortOrder:
        sortOrder === "asc" && orderByName === "updatedOn"
          ? "ascend"
          : sortOrder === "desc" && orderByName === "updatedOn"
            ? "descend"
            : undefined,
    },
  ];

const filteredData = totalRecords?.filter((item: any) => {
  return parseFloat(item.docVersion) !== 1.0;
});

  const uploadProps: UploadProps = {
    onRemove: (file) => handleRemove(file),
    onChange: (info: any) => {
      if (info.file.type !== "application/pdf") {
        message.error("Incorrect format, only PDF files are allowed");
        return;
      }

      if (editDocument.length >= 10) {
        message.error("Adding the file exceeds the limit");
        return;
      }

      newDocId++;
      info.documentId = newDocId;
      if (info.file.size <= 40 * 1024 * 1024) {
        if (isUpdateFile) {
          handleFileChange(info, true);
          setIsUpdateFile(false);
        } else {
          handleFileChange(info);
        }
      } else {
        message.error("Adding the file exceeds the 40 MB limit");
      }
    },
    beforeUpload: (file) => {
      return false;
    },
  };

  const UpdateDocList = (value: any, isloading: boolean) => {
    setDocsList(value);
    setBgIsLoading(isloading);
  };

 const viewDocument = (envelope: any, isDownload = false) => {
  if (loadingDocId) return;

  setLoadingDocId(envelope.documentId);

  if (!envelope.isNew) {
    const fileUrl = envelope.blobUrl + docVersionKey;

    if (isDownload) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = envelope.name;
      link.click();
    } else {
      window.open(fileUrl, "_blank");
    }

    setLoadingDocId("");
  } else {
    const byteCharacters = atob(envelope.documentBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const file = new Blob([byteArray], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);

    if (isDownload) {
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = envelope.name;
      link.click();
    } else {
      window.open(fileURL, "_blank");
    }

    setLoadingDocId("");
  }
};

  const handleRemove = (file: any) => {
    if (!file?.isNew) {
      setDeleteId([...deleteId, file.documentId]);
    }
    if (file?.documentId) {
      setUpdatedFile(updatedFile?.filter((item: any) => item.documentId != file.documentId));
      setCreatedFile(createdFile?.filter((item: any) => item.documentId != file.documentId));
      setEditDocument(editDocument?.filter((item: any) => item.documentId != file.documentId));
    }
  };

  const handleEdit = (file: any) => {
    if (file?.isNew) {
      message.info("Cannot Edit new files");
      return;
    }
    setUpdatedId([...updatedId, file?.documentId]);
    setIsUpdateFile(true);
    UploadRef?.current?.upload?.uploader?.onClick();
    setEditDocument(editDocument?.filter((item: any) => item.documentId != file.documentId));
  };

  const getPdfData = async (values: any) => {
    let logs = await get(`v1/auditlog/envelope/get-all-logs?envelopeId=${id}`);
    let docVersion = await get(`v1/spa/get/document/versions?envelopeId=${id}&order=desc&orderBy=updatedOn`);
    let comments = await get(`v1/workflow/getCommentsList?envelopeId=${id}&order=desc&orderBy=commentedOn`);
    return {
      ...data,
      ...values,
      reviewers,
      watchers,
      documents: values.documents ?? documents ?? [],
      logs: _get(logs, "response.data.records", []),
      docVersion: _get(docVersion, "response.data", []),
      comments: _get(comments, "response.data.records", []),
    };
  };

  const getPdfBlobFromDocDefinition = (docDefinition: any): Promise<Blob> => {
    return new Promise((resolve, reject) => {
      try {
        pdfMake.createPdf(docDefinition).getBlob((blob: Blob) => {
          resolve(blob);
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  const createPdfFile = (blob: Blob, fileName: string): File => {
    return new File([blob], fileName, {
      type: "application/pdf",
      lastModified: Date.now(),
    });
  };

  const generatePdfFileWithAllDocuments = async (allDocuments: any[]) => {
    const pdfData = await getPdfData({ documents: allDocuments });
    const docDefinition = printPdf(pdfData, "view");
    const pdfBlob = await getPdfBlobFromDocDefinition(docDefinition);
    const nextVersion = Number(data?.lastVersion ?? 0) + 1;

    return createPdfFile(pdfBlob, `SPA${data?.projectId}(V${nextVersion}).pdf`);
  };

const handleSubmit = async () => {
  if (updatedId.length !== updatedFile.length) {
    openNotification({
      title: "The Update file is missing, Please try again",
      message: "",
      type: "error",
    });
    return;
  }

  setButtonLoading(true);
  const versionKey = Math.floor(Math.random() * 1_000_000_000).toString();

  try {
    const maxExistingDocId = documents?.length
      ? Math.max(...documents.map((d: any) => parseInt(d.documentId, 10) || 0))
      : 0;

    let randomCreateId = maxExistingDocId;

    let shouldGenerateOverallPdf = false;

     if (deleteId.length > 0 || createdFile.length > 0) {
      const lockRes: any = await put(
        `v1/workflow/document-lock?envelopeId=${id}&versionOrder=${totalVersion}&versionKey=${versionKey}`,
        ""
      );
      if (lockRes.status !== "OK") throw new Error("Document lock failed");
    }

    const overallPdfRegex = new RegExp(`^SPA${data?.projectId}\\(V\\d+\\)\\.pdf$`);
    const existingOverallDoc = documents.find((d: any) =>
      overallPdfRegex.test(d.documentName)
    );

    const deleteIdWithOverall =
      existingOverallDoc && !deleteId.includes(existingOverallDoc.documentId)
        ? [...deleteId, existingOverallDoc.documentId]
        : deleteId;

    const deleteFormData = new FormData();
    deleteFormData.append("envelopeId", id);
    deleteFormData.append("delete_id", deleteIdWithOverall.join(","));

    const remainingDocs = documents.filter(
      (d: any) => !deleteIdWithOverall.includes(d.documentId)
    );

    deleteFormData.append("existing_id", remainingDocs.map((d: any) => d.documentId).join(","));
    deleteFormData.append(
      "existing_file_names",
      remainingDocs.map((d: any) => encodeURIComponent(d.documentName))
    );
    deleteFormData.append("versionOrder", `${totalVersion}`);
    deleteFormData.append("versionKey", versionKey);

      await post("v1/spa/delete/spaDocument", deleteFormData);
      shouldGenerateOverallPdf = true;

    if (createdFile && createdFile.length > 0) {
      for (const fileInfo of createdFile) {
        const createFormData = new FormData();
        createFormData.append("envelopeId", id);
        createFormData.append("create-document-file", fileInfo.file);
        createFormData.append("create_id", `${randomCreateId + 1}`);
        createFormData.append("versionOrder", `${totalVersion}`);
        createFormData.append("versionKey", versionKey);

        await put("v1/spa/update/spaDocument", createFormData);
        randomCreateId += 1;
      }
      shouldGenerateOverallPdf = true;
    }

    if (shouldGenerateOverallPdf) {
      const updatedDocsResponse: any = await get(
        `v1/workflow/get/document/version?envelopeId=${id}&docVersion=${totalVersion}`
      );
      const allDocuments = updatedDocsResponse?.response?.data || [];
      const overallPdfFile: any = await generatePdfFileWithAllDocuments(allDocuments);

      const overallFormData = new FormData();
      overallFormData.append("envelopeId", id);
      overallFormData.append("create-document-file", overallPdfFile);
      overallFormData.append("create_id", `${randomCreateId + 1}`);
      overallFormData.append("versionOrder", `${totalVersion}`);
      overallFormData.append("versionKey", versionKey);

      await put("v1/spa/update/spaDocument", overallFormData);
    }

    await put(`v1/spa/trigger/document-version-mail?envelopeId=${id}&versionOrder=${totalVersion}`, {});

    setRefreshData((prev: any) => !prev);
    setIsModalOpen(false);
    setEditDocument(documents);
    setDeleteId([]);
    setUpdatedId([]);
    setUpdatedFile([]);
    setCreatedFile([]);
  } catch (err: any) {
    console.error(err);
    openNotification({
      title: err.message || "Something went wrong",
      message: "",
      type: "error",
    });
  } finally {
    setButtonLoading(false);
  }
};

const overallPdfRegex = new RegExp(`^SPA${data?.projectId}\\(V\\d+\\)\\.pdf$`);

  return (
    <ContentWrapper
      loading={isLoading}
      title={"SPA Versions"}
      actionItems={
        !hasKeyString("watcher") &&
        !hasKeyString("review") &&
        hasRole(["SPA_ADMIN", "SPA_USER", "SPA_APPROVER"]) &&
        !isLoading &&
        data.status !== "completed" && (
          <Button
            type="primary"
            onClick={() => setIsModalOpen(true)}
          >
            <Space>
              <Icon
                icon="akar-icons:plus"
                inline
              />
              Add
            </Space>
          </Button>
        )
      }
    >
      {isBgLoading && (
        <div className="loadingOverlay">
          <Space size="middle">
            <Spin size="large" />
          </Space>
        </div>
      )}
      <DataTable
        columns={columns?.map((column) => ({
          ...column,
          onHeaderCell: (column: any) => ({
            onClick: () => {
              if (column.sorter) {
                handleTableSort(column, sortOrder, page ? page : 0);
              }
            },
          }),
        }))}
        excludeSearchCols={["updatedTime"]}
        className="table-clickable"
        tableData={filteredData?.map(({ ...d }: any) => {
          return {
            ...d,
            key: `${d.docVersion}`,
            documentVersion: `${d.docVersion}`,
            updatedTime: d.updatedOn ? d.updatedOn : d.createdOn,
          };
        })}
        onRowExpand={(e) => setActiveExpRow(e)}
        expandable
        onSearchChange={handleSearchChange}
        clearStringSearch={clearSearch}
        isServerSearchApi={true}
        inputDisable={isLoading}
        searchPlaceholderText={"Search Document Version"}
        expandRenderer={(value) => {
          return (
            <ExpandedView
              orderKey={value.docVersion}
              order={value.order}
              activeExpRow={activeExpRow}
              envelopeId={value.envelopeId}
              getTemplateRecords={getTemplateRecords}
              docsList={docsList}
              emptyDocList={UpdateDocList}
              data={data}
              fullEnvelopDetails ={fullEnvelopeDetails}
            />
          );
        }}
        isLoading={false}
        exportFileName="Contracts"
        isPagination={true}
        hideExport={true}
        multiSelect={false}
      />
      <div className="pagination">
        <Pagination
          defaultCurrent={1}
          showSizeChanger={false}
          current={page + 1}
          onChange={(newPage) => {
            const startIndex = newPage - 1;
            setpage(newPage - 1);
            setPageStart(startIndex);
            getDocuments(startIndex, sortOrder, orderByName, searchString);
          }}
          total={totalRecords && totalPage}
        />
      </div>
      <Modal
        maskClosable={false}
        title="Edit Documents"
        open={isModalOpen}
        okButtonProps={{
          loading: buttonLoading,
          disabled:
            (deleteId.length === documents?.length && !(createdFile.length > 0 || updatedId.length > 0)) ||
            (deleteId.length == 0 && updatedId.length == 0 && createdFile.length == 0),
        }}
        okText={"Submit"}
        onOk={() => handleSubmit()}
        onCancel={() => {
          setIsModalOpen(false);
          setButtonLoading(false);
          setEditDocument(documents);
          setDeleteId([]);
          setUpdatedId([]);
          setUpdatedFile([]);
          setCreatedFile([]);
        }}
      >
        <Row style={{ marginBottom: 16 }}>
          <Col
            xs={24}
            md={24}
            style={{ marginBottom: 16 }}
          >
            <Typography.Text>
              <span>
                <Icon
                  icon="arcticons:documents"
                  fontSize={24}
                  style={{ color: styles.strawberry }}
                />
              </span>
              Please edit your files
            </Typography.Text>
          </Col>
          <Col
            xs={24}
            md={24}
          >
            <Row style={{ width: "100%", alignItems: "center" }}>
              <Col
                span={24}
                style={{ marginTop: styles.whitesapce3 }}
              >
                <Form.Item label="">
                  <Upload.Dragger
                    style={{
                      borderRadius: 10,
                      padding: 30,
                    }}
                    ref={UploadRef}
                    name="projects"
                    showUploadList={false}
                    multiple={false}
                    // maxCount={10}
                    accept=".pdf"
                    {...uploadProps}
                    // onChange={handleFileChange}
                  >
                    <Image
                      src={upload}
                      preview={false}
                    />
                    <br />
                    <Typography.Text>
                      Only PDF files are allowed
                      <br />
                    </Typography.Text>
                    <Typography.Text style={{ color: styles.strawberry }}>
                      (Maximum File Size: 40 MB)
                      <br />
                    </Typography.Text>
                    <Typography.Text style={{ color: styles.strawberry }}>(Maximum Files: 10)</Typography.Text>
                    <Typography.Text
                      className="ant-upload-text"
                      style={{
                        display: "flex",
                        marginBlock: styles.whitespace2,
                        justifyContent: "center",
                      }}
                    >
                      Click or drag file to this area to upload
                    </Typography.Text>
                  </Upload.Dragger>
                </Form.Item>
                {editDocument?.length > 0 &&
                  editDocument?.map((item: any, index: number) => {
                    if (item.type != "summary" && !overallPdfRegex.test(item.documentName)) {
                      return (
                        <div key={index}>
                          <Space style={{ marginBottom: styles.whitespace3 }}>
                            <Icon
                              icon="ph:file-pdf"
                              inline
                              fontSize={24}
                              className="doc-icon-secondary"
                              cursor="pointer"
                              style={{ marginRight: 8 }}
                              onClick={() => viewDocument(item)}
                            />
                            <Typography.Title level={5}>{item.documentName}</Typography.Title>
                            <Icon
                              icon="ic:outline-remove-red-eye"
                              inline
                              fontSize={24}
                              className="doc-icon-secondary"
                              cursor="pointer"
                              style={{ marginLeft: 16, marginRight: 8 }}
                              onClick={() => viewDocument(item)}
                            />
                            {/*<Icon*/}
                            {/*    icon="carbon:edit"*/}
                            {/*    inline*/}
                            {/*    className="doc-icon-secondary"*/}
                            {/*    fontSize={24}*/}
                            {/*    style={{*/}
                            {/*      marginLeft: 8,*/}
                            {/*      marginRight: 8,*/}
                            {/*      cursor: !item.isNew ? "pointer" : 'not-allowed'*/}
                            {/*    }}*/}
                            {/*    onClick={() => handleEdit(item)}*/}
                            {/*  />*/}
                            <Icon
                              icon="ic:outline-delete"
                              inline
                              className="doc-icon-secondary"
                              fontSize={24}
                              style={{
                                marginLeft: 8,
                                marginRight: 8,
                              }}
                              cursor="pointer"
                              onClick={() => handleRemove(item)}
                            />
                            {loadingDocId === item.documentId && (
                              <Icon
                                icon="eos-icons:bubble-loading"
                                inline
                                className="doc-icon-secondary"
                                fontSize={24}
                                style={{ marginLeft: 12, marginRight: 12 }}
                              />
                            )}
                          </Space>
                        </div>
                      );
                    }
                  })}
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal>
      <LoaderModal
        isOpenModal={loaderModal}
        filesUploadCount={filesUploadedCount}
        totalFiles={totalFiles}
        redirect={`/spa/view/${id}?activeTab=documentVersions`}
        retrigger={setRefreshData}
        isRearrangeable={false}
        envelopeId={id}
      />
      <SuccessModal
        title={"Document Version"}
        message={"You have successfully added  new version of document"}
        type={"success"}
        buttonText={"Go Back"}
        redirect={`/spa`}
        open={successOpen}
        setOpen={setSuccessOpen}
      />
      {selectedDocument && (
        <PDFViewer
          show={true}
          title={"View Document"}
          subTitle={""}
          setShow={() => setSelectedDocument("")}
          url={selectedDocument}
        />
      )}
    </ContentWrapper>
  );
};

const ExpandedView = ({
  orderKey,
  order,
  envelopeId,
  getTemplateRecords,
  docsList,
  activeExpRow,
  emptyDocList,
  data,
  fullEnvelopDetails
}: {
  orderKey: any;
  envelopeId: any;
  order: any;
  getTemplateRecords: (envelopeId: string, key: any) => void;
  docsList: any;
  activeExpRow: any;
  emptyDocList: (envelopeId: string, value: boolean) => void;
  fullEnvelopDetails:any;
  data:any;
}) => {
  const { id } = useParams();

  useEffect(() => {
    if (orderKey && activeExpRow && activeExpRow[0] === orderKey) {
      getTemplateRecords(envelopeId, order);
      emptyDocList("", true);
    }
  }, [activeExpRow]);

  return (
    <ContractDocument
      title=""
      documents={docsList}
      id={id}
      type={"url"}
      data={data}
      fullEnvelopDetails={fullEnvelopDetails}
    />
  );
};
